export function BundlesDao(RESOURCE, ArtifactoryDaoFactory) {
    return ArtifactoryDaoFactory()
        .setPath(RESOURCE.BUNDLES + "/:type/:name/:version")
        .setCustomActions({
            getData: {
                method: 'GET',
                isArray: false,
                params: {type : '@type', name: '@name'}
            },
            getBundleVersions: {
                method: 'GET',
                isArray: false,
                params: {type : '@type', name: '@name'}
            },
            getBundleData: {
                method: 'GET',
                isArray: false,
                params: {type : '@type', name: '@name', version: '@version'}
            },
            deleteBundles: {
                method: 'DELETE',
                isArray: false,
                params: {type : '@type', name: '@name', version: '@version'}
            }
        })
        .getInstance();
}



// WEBPACK FOOTER //
// ./data/dao/bundles_dao.js